import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @ts-expect-error Untyped module
import EmptyCustomSectionColumn from 'ContentEditorUI/components/sections/EmptyCustomSectionColumn';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UILink from 'UIComponents/link/UILink';
// @ts-expect-error Untyped module
import { updateSelectedCategory } from 'ContentEditorUI/redux/actions/sidebarActions';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
// @ts-expect-error Untyped module
import { openModal } from 'ContentEditorUI/redux/actions/appActions';
import { PATAGONIA_ADD_PANEL_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import { getDefaultSubCategoryMap } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InpageNoSavedSectionsMessage() {
  const dispatch = useDispatch();
  const defaultSelectedSubCategoryMap = useSelector(getDefaultSubCategoryMap);
  const layoutsSubCategory = defaultSelectedSubCategoryMap[PATAGONIA_ADD_PANEL_CATEGORIES.LAYOUTS];
  const goToLayoutsCallback = useCallback(() => {
    dispatch(updateSelectedCategory(PATAGONIA_ADD_PANEL_CATEGORIES.LAYOUTS, layoutsSubCategory));
  }, [dispatch, layoutsSubCategory]);
  const createYourOwnCallback = useCallback(() => {
    dispatch(openModal(MODAL_TYPES.SECTIONS_INSTRUCTIONAL_MODAL));
  }, [dispatch]);
  return /*#__PURE__*/_jsx(EmptyCustomSectionColumn, {
    message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "addSectionPanel.customSections.noSavedSectionsSecondary_jsx",
      options: {
        layoutClick: goToLayoutsCallback,
        createYourOwnClick: createYourOwnCallback
      },
      elements: {
        UILink
      }
    })
  });
}
InpageNoSavedSectionsMessage.propTypes = {};